import { render } from "./ReportsComponent.vue?vue&type=template&id=21eecd87"
import script from "./ReportsComponent.vue?vue&type=script&lang=js"
export * from "./ReportsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__